import { render, staticRenderFns } from "./DeliveryDistributionTable.vue?vue&type=template&id=672acd4a"
import script from "./DeliveryDistributionTable.vue?vue&type=script&lang=js"
export * from "./DeliveryDistributionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports